// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3ztVg","options":"AnswerScale_options__2To5q","selected":"AnswerScale_selected__HSjHx"};